import React from "react";
import PlatformNewsActionLink from "../components/PlatformNewsActionLink";
import PlatformNewsArticleHeader from "../components/PlatformNewsArticleHeader";
import PlatformNewsArticleSection from "../components/PlatformNewsArticleSection";
import PlatformNewsCallout from "../components/PlatformNewsCallout";
import PlatformNewsFeatureGrid from "../components/PlatformNewsFeatureGrid";
import PlatformNewsMediaGallery from "../components/PlatformNewsMediaGallery";

export default function PlatformNewsReleaseArticle({newsItem}) {
    const content = newsItem.content;

    if (!content) {
        return null;
    }

    return (
        <article className="platform-news-article">
            <PlatformNewsArticleHeader
                newsItem={newsItem}
                subtitle={content.subtitle}
            />

            {content.lead && content.lead.length > 0 && (
                <div className="platform-news-article__lead">
                    {content.lead.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                    ))}
                </div>
            )}

            {(content.sections || []).map((section) => (
                <PlatformNewsArticleSection
                    icon={section.icon}
                    title={section.title}
                    key={section.title}
                >
                    {section.paragraphs && section.paragraphs.map(
                        (paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                        )
                    )}

                    {section.list && section.list.length > 0 && (
                        <ul className="platform-news-article__list">
                            {section.list.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    )}

                    <PlatformNewsFeatureGrid
                        items={section.items}
                        headingLevel={section.itemHeadingLevel}
                    />
                </PlatformNewsArticleSection>
            ))}

            {newsItem.gallery && newsItem.gallery.length > 0 && (
                <PlatformNewsArticleSection
                    icon="📷"
                    title={content.galleryTitle || "Фотографии"}
                >
                    <PlatformNewsMediaGallery
                        items={newsItem.gallery}
                        galleryName={newsItem.id}
                    />
                </PlatformNewsArticleSection>
            )}

            <PlatformNewsCallout callout={content.callout}/>

            {content.notice && (
                <p className="platform-news-article__notice">
                    {content.notice}
                </p>
            )}

            <PlatformNewsActionLink
                action={content.action}
                className="platform-news-article__action"
            />
        </article>
    );
}
